import type { LookupModel } from './lookup.type.ts';

export interface AccountCategoryModel extends LookupModel {
  accountId: number;
  isDefault: boolean;
  frequency: FrequencyModel;
}

export interface FrequencyModel {
  id: FrequencyEnum;
  description: string;
}

export enum FrequencyEnum {
  Unlimited = 1,
  Weekly = 2,
  Monthly = 3,
  Quarterly = 4,
  SemiAnnually = 5,
  Annually = 6,
  Never = 7,
}
